import { render, staticRenderFns } from "./StudentWorks.vue?vue&type=template&id=aa39c17e&scoped=true&"
import script from "./StudentWorks.vue?vue&type=script&lang=js&"
export * from "./StudentWorks.vue?vue&type=script&lang=js&"
import style0 from "./StudentWorks.vue?vue&type=style&index=0&id=aa39c17e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa39c17e",
  null
  
)

export default component.exports